/* ============================================================
   MT — Scripts globales (vanilla, sin librerías)
   ============================================================ */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Reveals al hacer scroll (un solo observer compartido) --- */
  function initReveals() {
    var els = document.querySelectorAll('.mt-reveal');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('mt-visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { obs.observe(el); });
  }

  /* --- Cifras que cuentan --- */
  function animarNumero(el) {
    var target = parseFloat(el.getAttribute('data-num'));
    var dec = parseInt(el.getAttribute('data-dec') || '0', 10);
    var dur = 1500, t0 = null;
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min((ts - t0) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = (target * eased).toFixed(dec);
      if (p < 1) requestAnimationFrame(step); else el.textContent = target.toFixed(dec);
    }
    requestAnimationFrame(step);
  }
  function initContadores() {
    var nums = document.querySelectorAll('[data-num]');
    if (!nums.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      nums.forEach(function (el) { el.textContent = parseFloat(el.getAttribute('data-num')).toFixed(parseInt(el.getAttribute('data-dec') || '0', 10)); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { animarNumero(e.target); obs.unobserve(e.target); }
      });
    }, { threshold: 0.6 });
    nums.forEach(function (el) { obs.observe(el); });
  }

  /* --- FAQ desplegable --- */
  function initFaq() {
    var items = document.querySelectorAll('.mt-faq__item');
    if (!items.length) return;
    items.forEach(function (item) {
      var q = item.querySelector('.mt-faq__q');
      var a = item.querySelector('.mt-faq__a');
      if (!q || !a) return;
      q.addEventListener('click', function () {
        var open = item.classList.contains('mt-open');
        if (open) { item.classList.remove('mt-open'); a.style.maxHeight = null; }
        else { item.classList.add('mt-open'); a.style.maxHeight = a.scrollHeight + 'px'; }
      });
    });
  }

  /* --- Galería de producto --- */
  function initGaleria() {
    var main = document.querySelector('.mt-prod__gal-main img');
    var thumbs = document.querySelectorAll('.mt-prod__thumb');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-src');
        if (src) main.src = src;
        thumbs.forEach(function (x) { x.classList.remove('mt-active'); });
        t.classList.add('mt-active');
      });
    });
  }

  /* --- Parallax suave del hero --- */
  function initParallax() {
    if (reduce) return;
    var frame = document.querySelector('.mt-hero__frame');
    if (!frame) return;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (y < 800) frame.style.transform = 'translateY(' + (y * 0.04) + 'px)';
    }, { passive: true });
  }

  /* --- Pack: agrega los dos productos de una vez --- */
  function initPack() {
    var btns = document.querySelectorAll('.mt-pack__add');
    if (!btns.length) return;
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var a = btn.getAttribute('data-a');
        var b = btn.getAttribute('data-b');
        if (!a || !b) return;
        var original = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Agregando…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: a, quantity: 1 }, { id: b, quantity: 1 }] })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          window.location.href = '/cart';
        }).catch(function () {
          btn.disabled = false;
          btn.textContent = original;
          alert('No pudimos agregar el pack. Inténtalo de nuevo.');
        });
      });
    });
  }

  /* --- Contador de oferta (a una fecha real) --- */
  function initCuentaRegresiva() {
    var els = document.querySelectorAll('[data-mt-cuenta]');
    if (!els.length) return;
    els.forEach(function (el) {
      var raw = (el.getAttribute('data-fin') || '').trim().replace(' ', 'T');
      var fin = new Date(raw);
      if (isNaN(fin.getTime())) { el.style.display = 'none'; return; }
      var d = el.querySelector('[data-d]'), h = el.querySelector('[data-h]'),
          m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function tick() {
        var dif = fin.getTime() - Date.now();
        if (dif <= 0) {
          var txt = el.previousElementSibling;
          if (txt && txt.classList.contains('mt-cuenta__txt')) txt.style.display = 'none';
          el.style.display = 'none';
          clearInterval(id);
          return;
        }
        var seg = Math.floor(dif / 1000);
        d.textContent = Math.floor(seg / 86400);
        h.textContent = pad(Math.floor(seg % 86400 / 3600));
        m.textContent = pad(Math.floor(seg % 3600 / 60));
        s.textContent = pad(seg % 60);
      }
      tick();
      var id = setInterval(tick, 1000);
    });
  }

  /* --- Barra de envío gratis (se refresca con el carrito real) --- */
  function initEnvio() {
    var bar = document.querySelector('[data-mt-envio]');
    if (!bar) return;
    var umbral = parseInt(bar.getAttribute('data-umbral') || '0', 10);
    if (!umbral) return;
    var txtEl = bar.querySelector('[data-mt-envio-txt]');
    var fill = bar.querySelector('[data-mt-envio-fill]');
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var actual = c.total_price;
      var falta = Math.max(umbral - actual, 0);
      var pct = Math.min(Math.round(actual * 100 / umbral), 100);
      if (fill) fill.style.width = pct + '%';
      if (falta === 0) {
        bar.classList.add('mt-envio--ok');
        if (txtEl) txtEl.textContent = bar.getAttribute('data-texto-ok');
      } else {
        bar.classList.remove('mt-envio--ok');
        var money = '$' + (falta / 100).toLocaleString('es-CL');
        if (txtEl) txtEl.textContent = (bar.getAttribute('data-texto-falta') || '').replace('[monto]', money);
      }
    }).catch(function () {});
  }

  /* --- Carrito: agregar el producto sugerido --- */
  function initCross() {
    var btns = document.querySelectorAll('[data-mt-cross-add]');
    if (!btns.length) return;
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-mt-cross-add');
        if (!id) return;
        btn.disabled = true;
        btn.textContent = 'Agregando…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        }).then(function () { window.location.reload(); })
          .catch(function () { btn.disabled = false; btn.textContent = 'Agregar'; });
      });
    });
  }

  function boot() {
    initReveals();
    initContadores();
    initFaq();
    initGaleria();
    initParallax();
    initPack();
    initCuentaRegresiva();
    initEnvio();
    initCross();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
